import React from "react";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";
import Subtopic from "../../../components/Subtopic/Subtopic";
import Subsubtopic from "../../../components/Subsubtopic/Subsubtopic";
import ListOrdered from "../../../components/ListOrdered/ListOrdered";
import AudioPlayer from "../../../components/AudioPlayer/AudioPlayer";
import Audio440 from "../../../assets/audio/440.wav";
import Audio442 from "../../../assets/audio/442.wav";
import SchwebungImage from "../../../assets/images/SIGA_Audacity/Schwebung.jpg";

const SigaPage = () => {
  return (
    <>
      <TopicFrame topicType="signalTheorie" entryNumber={2}>
        <Subtopic Title="Installation">
          <div className="bodyText">
            Audacity kann einfach von der offiziellen Website unter{" "}
            <a href="https://www.audacity.de/downloads/" target="_blank">
              https://www.audacity.de/downloads/
            </a>{" "}
            heruntergeladen werden. Es bietet vielfältige Funktionen wie die Aufnahme und Bearbeitung von Audiodateien,
            unterstützt verschiedene Dateiformate und ermöglicht deren Konvertierung. Darüber hinaus bietet Audacity
            Tools für Spektralanalysen, Spektrogramme und weitere Analysefunktionen, die besonders im Bereich der
            Signaltheorie von Bedeutung sind.
          </div>
        </Subtopic>
        {/* <Subtopic Title="Hochpass- und Tiefpass-Filter"></Subtopic> */}
        <Subtopic Title="Schwebung">
          <Subsubtopic Title="Was ist Schwebung?">
            <div className="bodyText">
              Schwebung ist ein akustisches Phänomen, das auftritt, wenn zwei Töne ähnlicher, aber nicht identischer
              Frequenz gleichzeitig gespielt werden. Da ihre Frequenzen nur leicht unterschiedlich sind, überlagern sich
              die Wellen der beiden Töne und interferieren miteinander.
            </div>
            <div className="bodyText">
              Das Ergebnis dieser Interferenz ist eine Welle, deren Amplitude (oder Lautstärke) sich periodisch
              verändert - sie wird lauter und leiser in einem Muster, das als Schwebung bezeichnet wird. Die
              Schwebungsfrequenz, also wie schnell diese Lautstärkeänderungen auftreten, entspricht der Differenz der
              Frequenzen der beiden Töne. Diese Schwebungen sind hörbar als eine Art Wobbeln oder Pulsieren des Tones.
            </div>
          </Subsubtopic>
          <Subsubtopic Title="Umsetzung in Audacity">
            <ListOrdered>
              <div>
                Mono-Spuren hinzufügen: <span className="monoFont">{"Erzeugen > Klang"}</span>
              </div>
              <div>
                Generierung zweier Sinustöne, einer mit einer Frequenz von 400 Hz, der andere mit 442 Hz; alternativ
                hier herunterladen und importieren:
              </div>
            </ListOrdered>
            <AudioPlayer src={Audio440} description="440 Hz" />
            <AudioPlayer src={Audio442} description="442 Hz" />
            <ListOrdered startnr={3}>
              <div>
              Tonspuren auswählen und Mischen: <span class="monoFont">{"Spuren > Mix > In neue Spur mischen und rendern"}</span>
              </div>
            </ListOrdered>
                    <div class="image padding30">
                    <img src={SchwebungImage} alt="Schwebung" />
                    </div>
          </Subsubtopic>
        </Subtopic>
      </TopicFrame>
    </>
  );
};

export default SigaPage;
